import { call, put, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'

import bulkOrderModel, { BulkOrder } from '@/core/models/bulk-order.model'
import { SearchResponse } from '@/core/types/response'

import {
  getBulkOrder as getBulkOrderAction,
  getBulkOrderFailure as getBulkOrderFailureAction,
  getBulkOrderSuccess as getBulkOrderSuccessAction,
  listBulkOrders as listBulkOrdersAction,
  listBulkOrdersSuccess as listBulkOrdersSuccessAction,
  listBulkOrdersFailure as listBulkOrdersFailureAction,
  updateBulkOrder as updateBulkOrderAction,
  updateBulkOrderSuccess as updateBulkOrderSuccessAction,
  updateBulkOrderFailure as updateBulkOrderFailureAction,
} from '@/redux/reducers/bulk-order.reducer'
import { handleError } from '@/utils/errors'

function* getBulkOrder(action: PayloadAction<ReturnType<typeof getBulkOrderAction>['payload']>) {
  try {
    const bulkOrder: BulkOrder = yield call(bulkOrderModel.getBulkOrder, action.payload)
    yield put(getBulkOrderSuccessAction(bulkOrder))
  } catch (error) {
    yield put(getBulkOrderFailureAction(handleError(error)))
  }
}

export function* listBulkOrders(action: PayloadAction<ReturnType<typeof listBulkOrdersAction>['payload']>) {
  try {
    const { query, options } = action.payload
    const { items, totalCount }: SearchResponse<BulkOrder> = yield call(bulkOrderModel.listBulkOrders, query, options)
    yield put(listBulkOrdersSuccessAction({ items, totalCount }))
  } catch (exception) {
    yield put(listBulkOrdersFailureAction(handleError(exception)))
  }
}

function* updateBulkOrder(action: PayloadAction<ReturnType<typeof updateBulkOrderAction>['payload']>) {
  try {
    const { bulkOrderId, updateBulkOrderDto } = action.payload
    const bulkOrder: BulkOrder = yield call(bulkOrderModel.updateBulkOrder, bulkOrderId, updateBulkOrderDto)
    yield put(updateBulkOrderSuccessAction(bulkOrder))
  } catch (error) {
    yield put(updateBulkOrderFailureAction(handleError(error)))
  }
}

const sagas = [
  takeLatest(getBulkOrderAction.type, getBulkOrder),
  takeLatest(listBulkOrdersAction.type, listBulkOrders),
  takeLatest(updateBulkOrderAction.type, updateBulkOrder),
]

export default sagas
